import benefit_section_widget_0 from "file:///home/wldocker/wl-cms/sites/modules/benefit-section-widget/ui/src/benefit-section-widget.js";



import benefit_section_widget_0Stylesheet from "file:///home/wldocker/wl-cms/sites/modules/benefit-section-widget/ui/src/benefit-section-widget.scss";benefit_section_widget_0();